import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useState } from 'react';
import ChevronSVG from '../assets/svg/chevron-down.svg';

function CollapsingIcon({ isOpen = false, defaultPosition = 'down' }) {
  const [computedClass, setComputedClass] = useState('');

  useEffect(() => {
    function computePosition() {
      let sortClass = classNames(
        '',
        { '': defaultPosition === 'down' && !isOpen },
        { '-rotate-90 py-4': defaultPosition === 'left' && !isOpen },
        { '': defaultPosition === 'left' && isOpen },
      );

      setComputedClass(sortClass);
    }
    computePosition();
  }, [isOpen, defaultPosition]);

  return (
    <React.Fragment>
      <img src={ChevronSVG} alt='' srcset='' className={computedClass} />
    </React.Fragment>
  );
}

export default CollapsingIcon;
